import { createRoot } from 'react-dom/client';
import { createBrowserHistory } from 'history';
import { ContextProvider } from '@epam/uui-core';
import { Snackbar, Modals } from '@epam/uui-components';
import { ErrorHandler, skinContext as promoSkinContext } from '@epam/promo';
import '@epam/uui-components/styles.css';
import '@epam/promo/styles.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { App } from './App';
import svc from './services';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const history = createBrowserHistory();
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 1000,
    },
  },
});

const UuiEnhancedApp = () => (
  <ContextProvider
    history={history}
    skinContext={promoSkinContext}
    onInitCompleted={(context) => Object.assign(svc, context)}>
    <ErrorHandler>
      <QueryClientProvider client={queryClient}>
        <Router>
          <App />
          <Snackbar />
          <Modals />
        </Router>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ErrorHandler>
  </ContextProvider>
);

const RoutedApp = () => <UuiEnhancedApp />;
const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<RoutedApp />);
